import { RemoveBankAccountActionResponse } from 'app/types/actions';
import commonStyles from 'common/commonStyles';
import Loader from 'common/components/Loader/Loader';
import DefaultError from 'common/components/StatusIndicator/DefaultError/DefaultError';
import { useGenericQuery } from 'common/hooks/useGenericQuery';
import { centraliseContent } from 'common/utils/styler';
import { API } from 'config/configureApi';
import { APP_LOCALE } from 'config/configureI18n';
import { cx } from 'emotion';
import { REMOVE_BANK_ACCOUNT_DETAILS_QUERY_KEY } from 'features/dashboard/components/OpenActions/constants';
import RemoveBankAccountActionDetailsTab from 'features/myactions/components/BankAccountActionDetails/RemoveBankAccountActionDetailsTab';
import ActionActivityTab from 'features/myactions/components/common/ActionActivityTab';
import { styles } from 'features/myactions/styles';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export interface RemoveBankAccountActionDetailsProps {
  id: string;
  type: string;
  isActivityTabOpen: boolean;
}

export default function RemoveBankAccountActionDetails({ id, type, isActivityTabOpen }: RemoveBankAccountActionDetailsProps): ReactElement {
  const { t } = useTranslation();
  const {
    data: removeBankAccountActionDetails,
    isFetching: isFetchingBankAccountActionDetails,
    error: removeBankAccountActionDetailsError,
    refetch: refetchRemoveBankAccountActionDetails,
  } = useGenericQuery<RemoveBankAccountActionResponse>(API.PROFILE.REMOVE_BANK_ACCOUNT_TRANSACTIONS(id), [REMOVE_BANK_ACCOUNT_DETAILS_QUERY_KEY, id]);

  const renderDefaultError = (): ReactElement => {
    return (
      <div className={commonStyles.detailsDefaultError}>
        <DefaultError
          size="small"
          errorCode={removeBankAccountActionDetailsError?.code}
          errorMessage={removeBankAccountActionDetailsError?.message}
          getDataError
          cta={{
            label: t(`${APP_LOCALE}:buttons.reload`),
            onClick: refetchRemoveBankAccountActionDetails,
          }}
        />
      </div>
    );
  };

  const renderRemoveBankAccountActionDetails = (): ReactElement => {
    return (
      <>
        {isActivityTabOpen && <ActionActivityTab activityDetails={removeBankAccountActionDetails?.activity} type={type} />}
        {!isActivityTabOpen && removeBankAccountActionDetails && <RemoveBankAccountActionDetailsTab {...removeBankAccountActionDetails} />}
      </>
    );
  };

  return (
    <>
      {isFetchingBankAccountActionDetails && (
        <Loader customClass={cx(styles.actionsItemDetailsLoader, centraliseContent(isFetchingBankAccountActionDetails))} />
      )}
      {!isFetchingBankAccountActionDetails && !!removeBankAccountActionDetailsError && renderDefaultError()}
      {!isFetchingBankAccountActionDetails && removeBankAccountActionDetails && renderRemoveBankAccountActionDetails()}
    </>
  );
}
